export const standardFilterFields = ['organizationId', 'countryCode', 'featureFlag'] as const;

export const filterFields = [...standardFilterFields] as const;
